import { MrbBaseRouteStore } from "mrb/core";
import { UserContentService } from "common/services";

class ShiurimRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);
        this.service = this.rootStore.createApplicationService(UserContentService);
    }

    async find(params) {
        const response = await this.service.findByPodcastCategory(params);
        return response.data;
    }

    async search(params) {
        const response = await this.service.genericSearch(params);
        return response.data;
    }
}

export default ShiurimRouteStore;
